// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__ec00A","container":"style_container__Oj-qY","frame":"style_frame__BK2gX","content":"style_content__p52rE"};